import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RegisteredService extends LocalStorageService<number> {

  constructor () {
    super('REGISTERED_INFO');
  }

  save() {
    this.value = 1;
  }
}
